document.addEventListener("DOMContentLoaded", function () {

  // ✅ Load liked videos from localStorage
  let likedVideos = [];
  try {
    const savedLikes = JSON.parse(localStorage.getItem("likedVideos") || "[]");
    if (Array.isArray(savedLikes)) likedVideos = savedLikes;
  } catch (error) {
    console.warn("Could not read saved video likes", error);
  }

  // ✅ Like Button Click
  document.querySelectorAll(".productVideocardapi .like-btn").forEach(function (btn) {
    btn.addEventListener("click", async function () {

      const parentCard = btn.closest(".productVideocardapi");
      const video = parentCard.querySelector(".videocardpopupapi video");
      const website = parentCard.dataset.videoWebsite || document.body.getAttribute("data-website");
      const title = parentCard.getAttribute("data-producttitle");
      const url = video?.querySelector("source")?.getAttribute("src");
      const likeCountSpan = btn.querySelector(".like-count");

      if (!url || !website || !title) return;

      // ✅ Check if user already liked this video
      if (likedVideos.includes(url)) {
        console.log("Already liked this video →", url);
        btn.classList.add("disabled");
        return;
      }

      // Prevent multi-click
      if (btn.classList.contains("disabled")) return;
      btn.classList.add("disabled");

      const formData = new FormData();
      formData.append("website", website);
      formData.append("title", title);
      formData.append("url", url);

      try {
        const response = await fetch(
          "https://digital.agarolifestyle.com/luvlap_api/Like-App/video-like.php",
          { method: "POST", body: formData }
        );
        if (!response.ok) throw new Error("Like request failed: " + response.status);
        const result = await response.json();
        console.log("Like update →", result);

        if (result.status === "success") {
             let count = parseInt(result.total_likes) || 0;

              function formatLikes(n) {
                  if (n >= 1_000_000) {
                      return (n / 1_000_000).toFixed(1).replace(".0", "") + "M";
                  }
                  if (n >= 1_000) {
                      return (n / 1_000).toFixed(1).replace(".0", "") + "k";
                  }
                  return n.toString();
              }

              const formattedCount = formatLikes(count);

              likeCountSpan.textContent = count > 0 ? `(${formattedCount})` : "";
              likeCountSpan.style.display = count > 0 ? "inline-block" : "none";


          // ✅ Save to localStorage so user can't like again
          likedVideos.push(url);
          try {
            localStorage.setItem("likedVideos", JSON.stringify(likedVideos));
          } catch (error) {
            console.warn("Like saved, but browser storage is unavailable", error);
          }
        } else {
          btn.classList.remove("disabled");
          console.error("Like was not saved", result.message || result.status);
        }

      } catch (err) {
        btn.classList.remove("disabled");
        console.error("Like Error", err);
      }
    });
  });





 // ✅ Like count number formatter
function formatLikes(num) {
  if (num >= 1000000) return (num / 1000000).toFixed(1).replace(/\.0$/, '') + "M";
  if (num >= 1000) return (num / 1000).toFixed(1).replace(/\.0$/, '') + "k";
  return num.toString();
}

// ✅ First time like count show (Product Page)
async function initAllCards() {
  const videoCards = document.querySelectorAll(".productVideocardapi");
  console.log("🎥 Total Video Cards:", videoCards.length);

  videoCards.forEach(async function (card) {
    const website = card.dataset.videoWebsite || document.body.getAttribute("data-website");
    const videoEl = card.querySelector(".videocardpopupapi video");
    const sourceEl = videoEl ? videoEl.querySelector("source") : null;
    const videoURL = sourceEl ? sourceEl.getAttribute("src") : null;
    const likeCountSpan = card.querySelector(".like-btn .like-count");

    if (!videoURL || !likeCountSpan || !website) {
      console.warn("⚠️ Missing required data → Skipped");
      return;
    }

    const formData = new FormData();
    formData.append("url", videoURL);
    formData.append("website", website);

    try {
      const response = await fetch(
        "https://digital.agarolifestyle.com/luvlap_api/Like-App/get-video-like.php",
        { method: "POST", body: formData }
      );

      const result = await response.json();
      const count = parseInt(result.total_likes) || 0;

      likeCountSpan.textContent = count > 0 ? `(${formatLikes(count)})` : "";
      likeCountSpan.style.display = count > 0 ? "inline-block" : "none";

      // ✅ Disable button if already liked
      if (typeof likedVideos !== "undefined" && likedVideos.includes(videoURL)) {
        const btn = card.querySelector(".like-btn");
        if (btn) btn.classList.add("disabled");
      }

    } catch (error) {
      console.error("❌ Like count fetch failed:", error);
      likeCountSpan.textContent = "";
      likeCountSpan.style.display = "none";
    }
  });
}

initAllCards();


});
